<mat-toolbar color="primary" id="file-manager-toolbar">
    <span>
        <button mat-icon-button (click)="toggleView()" [disabled]="!mediaFolder"
            matTooltip="{{ gridView ? ('file-manager.tooltip.toolbar-view-list' | translate) : ('file-manager.tooltip.toolbar-view-grid' | translate) }}">
            <mat-icon>{{ gridView ? 'view_list' : 'view_module' }}</mat-icon>
        </button>
        <button mat-icon-button [disabled]="!mediaFolder" (click)="uploadFiles()"
            matTooltip="{{ 'file-manager.tooltip.toolbar-upload' | translate }}">
            <mat-icon>cloud_upload</mat-icon>
        </button>
        <button mat-icon-button [disabled]="!mediaFolder" (click)="reloadFolder()"
            matTooltip="{{ 'file-manager.tooltip.toolbar-reload' | translate }}">
            <mat-icon>refresh</mat-icon>
        </button>
    </span>
    <div id="expanded-toolbar-right-panel" fxLayout="row" *ngIf="!gridView">
        <div *ngVar="getSelectedFiles().length as selectionLentgth">
            <button mat-icon-button (click)="renameSelected()" [disabled]="selectionLentgth != 1 || !mediaFolder"
                matTooltip="{{ 'file-manager.tooltip.toolbar-rename' | translate }}">
                <mat-icon>create</mat-icon>
            </button>
            <button mat-icon-button (click)="moveSelected()" [disabled]="selectionLentgth < 1 || !mediaFolder"
                matTooltip="{{ 'file-manager.tooltip.toolbar-move' | translate }}">
                <mat-icon>open_with</mat-icon>
            </button>
            <button mat-icon-button (click)="deleteSelected()" [disabled]="selectionLentgth < 1 || !mediaFolder"
                matTooltip="{{ 'file-manager.tooltip.toolbar-delete' | translate }}">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>
    <!--button mat-button [mat-menu-trigger-for]="menu" fxHide="false" fxHide.gt-sm>
    <mat-icon>menu</mat-icon>
  </button -->
</mat-toolbar>
<div style="height: auto;">
    <div *ngIf="gridView" gdGap="10px" gdColumns="repeat(auto-fill, minmax(200px, 1fr))">
        <!--TODO tolgo da id e metto class-->
        <div id="grid-file-container" *ngFor="let file of files">
            <div class="file-content" (contextmenu)="onContextMenu($event, file)"
                matTooltip="{{ 'file-manager.tooltip.download-file' | translate: { filename: file.getName(utils.getLanguage()) } }}"
                [ngClass]="[selectedFile && selectedFile.mediaFileId == file.mediaFileId ? 'selected-file': '']"
                (click)="downloadFile(file)">
                <div class="img">
                    <mat-icon *ngIf="!file.previewUrl">insert_drive_file</mat-icon>
                    <div *ngIf="file.previewUrl" class="file-preview-container"><img [src]="file.previewUrl"></div>
                </div>
                <div class="filename">{{ file.getName(utils.getLanguage()) }}</div>
            </div>
        </div>
    </div>
    <div *ngIf="!gridView && listDataSource">
        <table id="list-file-container" mat-table [dataSource]="listDataSource">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> {{ 'file-manager.label.name' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.getName(utils.getLanguage()) }} </td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> {{ 'file-manager.label.description' | translate }} </th>
                <td mat-cell *matCellDef="let element"> {{ element.getDescription(utils.getLanguage()) }} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
            </tr>
        </table>
    </div>
</div>

<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu" #fileMenuTrigger>
</div>
<mat-menu #contextMenu="matMenu">
    <ng-template matMenuContent let-file="file">
        <button mat-menu-item (click)="downloadFile(file)">
            <mat-icon class="tree-folder-icon">
                cloud_download
            </mat-icon>
            {{ 'file-manager.button.download' | translate }}
        </button>
        <button mat-menu-item (click)="renameFile(file)">
            <mat-icon class="tree-folder-icon">
                create
            </mat-icon>
            {{ 'file-manager.button.rename' | translate }}
        </button>
        <button mat-menu-item (click)="moveFile(file)">
            <mat-icon class="tree-folder-icon">
                open_with
            </mat-icon>
            {{ 'file-manager.button.move' | translate }}
        </button>

        <button mat-menu-item (click)="editPreview(file)">
            <mat-icon class="tree-folder-icon">
                image
            </mat-icon>
            {{ file.previewUrl ? ('file-manager.button.edit-preview' | translate) :  ('file-manager.button.add-preview' | translate)}}
        </button>

        <button mat-menu-item (click)="deleteFile(file)">
            <mat-icon class="tree-folder-icon">
                delete
            </mat-icon>
            {{ 'file-manager.button.delete' | translate }}
        </button>
    </ng-template>
</mat-menu>